import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center bg-background-50 overflow-hidden">
      <div className="w-full px-4 md:px-8 pt-24 pb-16 md:pt-28 md:pb-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-[42%] flex flex-col items-start text-left">
            <p className="text-xs tracking-[0.2em] uppercase text-accent-600 font-medium mb-4">
              #1 China Sourcing Tool
            </p>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-[1.08] tracking-tight">
              Find the Best{' '}
              <span className="italic text-accent-600">itaobuyspreadsheet</span>
              {' '}for Smart China Sourcing
            </h1>
            <p className="mt-5 md:mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              A powerful spreadsheet system that helps you discover verified products, compare prices, and optimize your sourcing from China with trusted data-driven listings.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mt-7 md:mt-8">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-file-excel-2-line text-base"></i>
                </div>
                itaobuy sheet
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 border-2 border-primary-500 text-primary-600 rounded-full text-sm font-semibold hover:bg-primary-500 hover:text-background-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-shopping-bag-3-line text-base"></i>
                </div>
                buy it now
              </a>
            </div>

            <p className="mt-5 text-xs text-foreground-400">
              Used by resellers, dropshippers, and global buyers for safer and faster sourcing decisions.
            </p>
          </div>

          <div className="w-full lg:w-[58%]">
            <div className="relative rounded-3xl overflow-hidden h-[320px] sm:h-[400px] md:h-[480px] lg:h-[560px]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20ecommerce%20fashion%20flatlay%20with%20diverse%20colorful%20sneakers%20leather%20handbags%20gold%20watches%20and%20silk%20scarves%20arranged%20on%20white%20marble%20surface%20with%20green%20monstera%20leaf%20accents%20editorial%20product%20photography%20with%20crisp%20shadows%20bright%20natural%20window%20light%20high%20contrast%20clean%20professional%20aesthetic&width=1200&height=1400&seq=hero-main-v3-2026&orientation=portrait"
                alt="itaobuyspreadsheet product sourcing - diverse fashion items on marble surface"
                title="itaobuyspreadsheet - Product Sourcing Spreadsheet Tool"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/15 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {[
            { icon: 'ri-shield-check-line', label: 'Verified Listings' },
            { icon: 'ri-flashlight-line', label: 'Fast Comparison' },
            { icon: 'ri-lock-2-line', label: 'Secure Access' },
            { icon: 'ri-refresh-line', label: 'Updated Daily' },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-2 text-foreground-500">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className={`${item.icon} text-base text-accent-500`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}